import { render, staticRenderFns } from "./linkShareDialog.vue?vue&type=template&id=6b6963b3&scoped=true&"
import script from "./linkShareDialog.vue?vue&type=script&lang=ts&"
export * from "./linkShareDialog.vue?vue&type=script&lang=ts&"
import style0 from "./linkShareDialog.vue?vue&type=style&index=0&id=6b6963b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6963b3",
  null
  
)

export default component.exports